export type ScreenLockCohort = 'control' | 'pilot';

class FeedToolsPilotService {
  private readonly pilotSize = 100;

  private hash(input: string): number {
    let value = 0;
    for (let i = 0; i < input.length; i += 1) {
      value = (value << 5) - value + input.charCodeAt(i);
      value |= 0;
    }
    return Math.abs(value);
  }

  getScreenLockCohort(userId?: string): ScreenLockCohort {
    if (!userId) return 'control';
    const index = this.hash(userId) % this.pilotSize;
    return index < this.pilotSize / 2 ? 'control' : 'pilot';
  }

  isScreenLockPilotEnabled(userId?: string): boolean {
    return this.getScreenLockCohort(userId) === 'pilot';
  }
}

export const feedToolsPilotService = new FeedToolsPilotService();
